import {
    AfterViewInit,
    Component,
    forwardRef,
    inject,
    ViewChild,
    ChangeDetectionStrategy
} from "@angular/core";
import { FormsModule } from "@angular/forms";
import { InputComponent as InputComponent_1 , InputComponent } from "@components/input/input.component";
import { MultiSelectorComponent } from "@components/multi-selector/multi-selector.component";
import { TranslatePipe } from "@ngx-translate/core";

import { IVirkeskopare } from "~app/features/planera/model/IVirkeskopFilter";
import { ArbetsorderSearchService } from "~app/features/planera/services/arbetsorder-search.service";
import { ArbetsorderSearchFilterComponent } from "../../components/arbetsorder-search-filter/arbetsorder-search-filter.component";
import { ArbetsorderSearchBasePanel } from "../../models/arbetsorder-search-base-panel";

@Component({
    selector: "rask-arbetsorder-search-virkeskop",
    templateUrl: "./arbetsorder-search-virkeskop.component.html",
    styleUrls: ["./arbetsorder-search-virkeskop.component.scss"],
    providers: [
        { provide: ArbetsorderSearchBasePanel,
            useExisting: forwardRef(() => ArbetsorderSearchVirkeskopComponent) }
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        ArbetsorderSearchFilterComponent,
        InputComponent_1,
        FormsModule,
        MultiSelectorComponent,
        TranslatePipe
    ]
})
export class ArbetsorderSearchVirkeskopComponent extends ArbetsorderSearchBasePanel implements AfterViewInit {
    @ViewChild("kontraktsnummerControl") kontraktsnummerControl: InputComponent;
    @ViewChild("prislistaControl") prislistaControl: InputComponent;

    private readonly arbetsorderSearchService = inject(ArbetsorderSearchService);

    forceUpdateFilterChange(): void {
        this.updateFilterValues();
    }

    isDirty(): boolean {
        return (
            (!!this.searchFilter.virkeskop?.kontraktsnummer) ||
            (this.searchFilter.virkeskop?.virkeskopare?.length > 0 && Array.isArray(this.searchFilter.virkeskop?.virkeskopare)) ||
            (!!this.searchFilter.virkeskop?.prislista)
        );
    }

    ngAfterViewInit() {
        this.updateFilterValues();
    }

    onChangeAnsvarigVirkeskopare(event: IVirkeskopare[]) {
        this.searchFilter.virkeskop.virkeskopare = event;
    }

    getAnvandareTypeAhead = (input: string) => this.arbetsorderSearchService.getAnvandareTypeAhead(input);

    updateFilterValues() {

        if (!this.searchFilter.virkeskop.kontraktsnummer) {
            if (this.kontraktsnummerControl.privateValue) {
                this.kontraktsnummerControl.privateValue = undefined;
            }
        }

        if (!this.searchFilter.virkeskop.prislista) {
            if (this.prislistaControl.privateValue) {
                this.prislistaControl.privateValue = undefined;
            }
        }
    }
}
